module.exports = __webpack_public_path__ + "images/bannerFR-dd3c190c8865d8189f53bb4e8a2252b1.jpg";